import ApiService, { errorMessage } from "helpers/ApiHelper";

const ROOT = "/api/v1/promotions";

export { errorMessage };

/**
 * All promotions for the admin, drafts included and in site order — unlike
 * the public read, which serves only published ones.
 */
export const fetchPromotions = () => ApiService.request(ROOT, "get");

export const createPromotion = (promotion) => ApiService.request(ROOT, "post", promotion);

export const updatePromotion = (id, promotion) =>
  ApiService.request(`${ROOT}/${id}`, "patch", promotion);

/**
 * Publishing is deliberately separate from saving — the same split
 * Testimonials and PromoBanners use: going live is a decision, and a save
 * that could publish by accident is the one mistake this screen must not
 * allow.
 */
export const setPromotionStatus = (id, status) =>
  ApiService.request(`${ROOT}/${id}/status`, "patch", { status });

export const deletePromotion = (id) => ApiService.request(`${ROOT}/${id}`, "delete");
